import React from 'react'
import { Download } from '../../atoms/NewIcons'
import SvgSuccess from '../../atoms/NewIcons/Success'
import useTrans from '../../../hooks/useTrans'

const imageFormats = ['svg', 'png', 'jpg', 'jpeg']

const AnteprimaLogo = ({ file, src, filename, className, download = true }) => {
  const t = useTrans()
  const isImage = file
    ? file.type.toString().toLowerCase().split('/')?.[0] === 'image'
    : filename
    ? imageFormats.includes(filename.toString().toLowerCase().split('.')?.[1] || '')
    : false

  if (file || src) {
    return isImage ? (
      <a
        href={file ? URL.createObjectURL(file) : src}
        {...(file ? { download: filename } : { target: '_blank' })}
      >
        <img src={file ? URL.createObjectURL(file) : src} className={className} />
      </a>
    ) : (
      <>
        {download && <a
          href={file ? URL.createObjectURL(file) : src}
          download={filename}
          {...(src ? { target: '_blank' } : {})}
          className={'posizione__anteprimaLogo'}
        >
          <span>
            <Download />
          </span>
        </a>}
        <span className="posizione__fileCaricato">
          <SvgSuccess />
          {t('File caricato correttamente')}
        </span>
      </>
    )
  }

  return null
}

export default AnteprimaLogo
